import React from 'react'
import LazyLoad from 'react-lazy-load'

import SelectCampaign from './SelectCampaign'
import styles from './GroupAddCreate/groupAddCreate.module.scss'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import { Button, Dialog, Text } from '@sendoutcards/quantum-design-ui'
import {
  GiftVariation,
  MinimalCampaignFragment,
} from 'src/graphql/generated/graphql'
import { useActions, useState } from 'src/hooks'
import { FlexRow } from 'src/styled'

type SelectCampaignModalProps = {
  isOpen: boolean
  unavailableGifts?: GiftVariation[]
  onClose: () => void
  onBack: () => void
  onSubmit: (campaign: MinimalCampaignFragment) => void
}

const UnavailableGift: React.FC<{
  giftVariation: GiftVariation
}> = props => {
  const { giftVariation } = props
  const title = giftVariation.name
  const titleLength = 35
  const displayTitle =
    title.length > titleLength
      ? title.substring(0, titleLength - 3) + '...'
      : title

  return (
    <div
      id={giftVariation.id}
      style={{
        display: 'flex',
      }}
    >
      <>
        <div
          style={{
            backgroundColor: '#eeefef',
            width: '62px',
            height: '62px',
          }}
        >
          <LazyLoad height={62} offset={62}>
            <div
              style={{
                backgroundImage: `url(${giftVariation.defaultImageUrl})`,
                width: '100%',
                height: '100%',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            />
          </LazyLoad>
        </div>
        <div>
          <Text type="largeBody" inset="x1">
            {displayTitle}
          </Text>
        </div>
      </>
    </div>
  )
}

const UnavailableGifts: React.FC<{
  campaignId: string
  unavailableGifts: GiftVariation[]
  onBack: () => void
}> = props => {
  const actions = useActions()
  const { unavailableGifts } = props
  const length = unavailableGifts.length
  const plural = length > 1 ? 's' : ''
  const handleOnBack = () => {
    props.onBack()
  }
  const handleOnUpdateCampaign = () => {
    actions.openCampaign(props.campaignId)
  }
  return (
    <>
      <Text type="body" inset="x0" outset={{ bottom: 'x1' }}>
        {`The selected campaign has ${length} unavailable gift${plural}:`}
      </Text>
      {props.unavailableGifts.map(value => (
        <UnavailableGift giftVariation={value} />
      ))}
      <FlexRow style={{ justifyContent: 'space-around', marginTop: '1rem' }}>
        <div>
          <Button
            id={'select_btn'}
            title="Back"
            backgroundColorOverride="#e841b3"
            onClick={handleOnBack}
            fontWeight="extraBold"
            size="small"
          />
        </div>
        <div>
          <Button
            id={'update_btn'}
            title="Update Campaign"
            backgroundColorOverride="#e841b3"
            onClick={handleOnUpdateCampaign}
            fontWeight="extraBold"
            size="small"
          />
        </div>
      </FlexRow>
    </>
  )
}

const SelectCampaignModal: React.FC<SelectCampaignModalProps> = props => {
  const { onSubmit, onClose, isOpen, unavailableGifts, onBack } = props
  const [selected, setSelected] = useState<MinimalCampaignFragment>()
  const title = unavailableGifts
    ? `${selected?.name}`
    : 'Select Campaign to Send'
  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <DialogTitle>
        <Text type="largeBody">{title}</Text>
      </DialogTitle>
      <DialogContent className={styles.modalContent}>
        {selected && unavailableGifts ? (
          <UnavailableGifts
            campaignId={selected?.id}
            unavailableGifts={unavailableGifts}
            onBack={onBack}
          />
        ) : (
          <SelectCampaign
            onClose={onClose}
            onSubmit={selectedCampaign => {
              setSelected(selectedCampaign)
              onSubmit(selectedCampaign)
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}

export default SelectCampaignModal
